import { PrivateRouteDefinition } from "../../../../infecto-lms-webapp/router/interfaces";
import { LandingPagesRoutes } from "./landing-pages.routes";

export const ImplNonAuthRoutes: PrivateRouteDefinition[] = [...LandingPagesRoutes];
